/**
 * VIP SUPPID 状态
 */
export enum VipSuppIdStatus {
  UNOCCUPIED = 0, // 未占用
  OCCUPIED = 1, // 已占用
}

/**
 * 搜索参数
 */
export interface VipSuppIdSearchParams {
  currentPage?: number;
  pageSize?: number;
}

/**
 * VIP 靓号响应（API 返回格式）
 */
export interface VipBeautifulNumberResp {
  id: number;
  beautifulNumber: number; // 靓号
  status: number; // 1:已占用,0:未占用
  deleteStatus: number; // 1:已删除,0:未删除
  updateTime: string; // 更新时间
  updateUserId: number; // 更新人ID
  updateUserName: string; // 更新人名称
}

/**
 * VIP SUPPID 记录
 */
export interface VipSuppIdRecord {
  id: number;
  suppId?: string; // VIP SUPPID（兼容旧字段）
  beautifulNumber: number | string; // VIP SUPPID（支持 number 和 string）
  status: VipSuppIdStatus; // 状态：0-未占用，1-已占用
  deleteStatus?: number; // 1:已删除,0:未删除
  updateTime: string; // 更新时间
  updateUserId?: number; // 更新人ID
  updateUserName: string; // 更新人名称
}

/**
 * VIP SUPPID 表单数据
 */
export interface VipSuppIdFormData {
  id?: number; // ID（编辑时传，新增时不传）
  beautifulNumber: string; // VIP SUPPID
}

/**
 * VIP SUPPID 列表响应
 */
export interface VipSuppIdListResponse {
  records: VipSuppIdRecord[];
  total: number;
  currentPage: number;
  pageSize: number;
}

/**
 * API 响应
 */
export interface VipSuppIdListApiResponse {
  status: number;
  success: boolean;
  message: string;
  data: {
    records: VipBeautifulNumberResp[];
    total: number;
    currentPage: number;
    pageSize: number;
  };
}

/**
 * VIP SUPPID 统计信息
 */
export interface VipSuppIdStats {
  usedCount: number; // 已占用数
  allCount: number; // 总数
}

